import { useState } from "react";
import AddTemplate from "../_templates/AddTemplate";
import QuickPlayerForm from "../../../components/players/QuickPlayerForm";
import { playerSchema } from "../../../schemas/player.schema";
import { createPlayer, listPlayers } from "../../../api/coredata.api";

// Looks for existing players with the same first+last name (case-
// insensitive). Returns up to 5 matches so a user about to duplicate
// "Rohit Sharma" sees the existing record and can open it instead.
async function checkDuplicatePlayer(values) {
  const first = (values.first_name || "").trim();
  const last  = (values.last_name  || "").trim();
  if (!first && !last) return [];
  const search = [first, last].filter(Boolean).join(" ");
  try {
    const res = await listPlayers(1, { search });
    const rows = res.data?.results || [];
    const norm = (s) => (s || "").trim().toLowerCase();
    const hits = rows.filter((p) =>
      norm(p.first_name) === norm(first) && norm(p.last_name) === norm(last),
    );
    return hits.slice(0, 5).map((p) => ({
      id: p.id,
      label: `${p.nick_name ? `${p.nick_name} — ` : ""}${p.first_name || ""} ${p.last_name || ""}`.trim()
        + (p.nationality ? ` (${p.nationality})` : ""),
      url: `/cricket/players/${p.id}/profile`,
    }));
  } catch {
    return [];
  }
}

export default function AddPlayer() {
  // 2026-06-06 — Detailed (full wizard) is the default. A "Quick mode"
  // link in the header top-right swaps to QuickPlayerForm for the
  // 7-field local-match flow (and back).
  const [mode, setMode] = useState("detailed");

  if (mode === "quick") {
    return <QuickPlayerForm onSwitchToDetailed={() => setMode("detailed")} />;
  }

  return (
    <div>
      <div className="max-w-2xl mx-auto p-3 sm:p-6 pb-0 flex justify-end">
        <button
          type="button"
          onClick={() => setMode("quick")}
          className="text-xs text-text-secondary hover:text-text-primary underline"
        >
          Quick mode
        </button>
      </div>
      <AddTemplate
        title="Add Player"
        schema={playerSchema}
        createFn={createPlayer}
        duplicateCheckFn={checkDuplicatePlayer}
        redirectPath="/cricket/players"
      />
    </div>
  );
}
